import { createMuiTheme } from '@material-ui/core/styles';
import * as colors from '../../../stylesheets/colors.scss';

const palette = {
  primary: {
    light: colors.blueTint,
    main: colors.blue,
    dark: colors.blueShade
  },
  secondary: {
    light: colors.greenTint,
    main: colors.green,
    dark: colors.greenShade
  },
  error: {
    light: colors.red,
    main: colors.red,
    dark: colors.red
  }
};

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Proxima Nova, Arial, sans-serif'
  },
  palette,
  overrides: {
    MuiOutlinedInput: {
      root: {
        height: '40px',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.lightGray,
          borderRadius: '8px'
        }
      },
      colorPrimary: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.primary.main
        }
      },
      colorSecondary: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.secondary.main
        }
      },
      colorError: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.error.main
        }
      },
      input: {
        color: colors.darkGray
      }
    },
    MuiFormLabel: {
      root: {
        '&[data-shrink=false]': {
          top: '-8px'
        },
        color: '#b2aea7'
      }
    }
  }
});

export default theme;
